<template>
  <div class="btn-delete-wrapper">
    <button
      v-if="isShowButton"
      type="button"
      class="btn-delete-trigger"
      @click="openConfirm"
    >
      <i class="el-icon-delete"></i> Eliminar
    </button>
    <button
      v-else
      type="button"
      class="btn-delete-trigger btn-delete-trigger--icon"
      @click="openConfirm"
    >
      <i class="el-icon-delete"></i>
    </button>

    <!-- Modal de confirmación segura -->
    <el-dialog
      :visible.sync="visible"
      width="420px"
      :show-close="false"
      append-to-body
      custom-class="delete-confirm-dialog"
    >
      <div class="dc-header">
        <div class="dc-header-icon">
          <i class="el-icon-warning-outline"></i>
        </div>
        <h5 class="dc-title">Confirmar eliminación</h5>
        <button class="dc-close" @click="cancel">
          <i class="el-icon-close"></i>
        </button>
      </div>

      <div class="dc-body">
        <p class="dc-desc">
          Esta acción es <strong>irreversible</strong>. Se eliminará este
          registro y todos los datos asociados de forma permanente.
        </p>

        <div class="dc-input-section">
          <label class="dc-label">
            Escribe <strong>Eliminar</strong> para confirmar:
          </label>
          <el-input
            v-model="confirmText"
            placeholder="Eliminar"
            size="small"
            @keydown.enter.native="confirmText === 'Eliminar' && confirm()"
          />
        </div>
      </div>

      <div class="dc-footer">
        <el-button size="small" @click="cancel">Cancelar</el-button>
        <el-button
          size="small"
          type="danger"
          :disabled="confirmText !== 'Eliminar'"
          @click="confirm"
        >
          <i class="el-icon-delete"></i> Eliminar permanentemente
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ButtonDeleteComponent",
  data() {
    return {
      visible: false,
      confirmText: ""
    };
  },
  methods: {
    openConfirm() {
      this.confirmText = "";
      this.visible = true;
    },
    confirm() {
      if (this.confirmText !== "Eliminar") return;
      this.$emit("onConfirmDelete");
      this.visible = false;
      this.confirmText = "";
    },
    cancel() {
      this.visible = false;
      this.confirmText = "";
    }
  },
  props: {
    isShowButton: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
$primary: #31355c;
$danger: #e24b4a;
$border: #e4eaf6;
$bg: #f7f8f9;

.btn-delete-wrapper {
  display: inline-flex;
}

.btn-delete-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 16px;
  border: 1px solid $border;
  border-radius: 8px;
  background: #fff;
  color: #909399;
  font-size: 13px;
  font-weight: 600;
  height: 36px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #fff0f0;
    border-color: $danger;
    color: $danger;
  }

  &--icon {
    padding: 8px;
    width: 36px;
    height: 36px;
    justify-content: center;
    font-size: 15px;
  }
}

.dc-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 20px;
  border-bottom: 1px solid $border;
  margin: -20px -20px 0;
}
.dc-header-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #fff0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i {
    font-size: 18px;
    color: $danger;
  }
}
.dc-title {
  font-size: 16px;
  font-weight: 700;
  color: $primary;
  margin: 0;
  flex: 1;
}
.dc-close {
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  border-radius: 8px;
  color: #909399;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  flex-shrink: 0;

  &:hover {
    background: #f0f2f7;
    color: $primary;
  }
}

.dc-body {
  padding: 20px 0 0;
}
.dc-desc {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  margin: 0 0 16px;
}
.dc-input-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.dc-label {
  font-size: 13px;
  color: $primary;
  font-weight: 500;
}

.dc-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 0 0;
  margin-top: 16px;
  border-top: 1px solid $border;
}
</style>

<style lang="scss">
.delete-confirm-dialog {
  border-radius: 12px !important;

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    padding: 20px !important;
  }
}
</style>
